import { motion } from 'framer-motion'

// Reveal pe linii „mascat": fiecare linie urcă din spatele unei măști (overflow hidden).
// Folosit pentru titluri — semnătura template-ului Gaspar.
const EASE = [0.22, 1, 0.36, 1]

// `onMount` = animă imediat (pentru hero/above-the-fold); altfel la scroll (whileInView).
export function RevealLines({ lines, className = '', delay = 0, stagger = 0.08, onMount = false }) {
  const anim = onMount
    ? { animate: { y: '0%' } }
    : { whileInView: { y: '0%' }, viewport: { once: true, margin: '-10% 0px' } }
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="line-mask">
          <motion.span
            className="block"
            initial={{ y: '110%' }}
            {...anim}
            transition={{ duration: 0.9, ease: EASE, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  )
}

// Fade-up simplu, scroll-triggered — pentru paragrafe, liste, carduri.
export function FadeUp({ children, className = '', delay = 0, y = 28 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.7, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  )
}
